// Node Modules
import { nanoid } from 'nanoid';

// Components
import Carousel from '@/components/global-components/carousel/Carousel';
import Photo from './Photo';

const defaultProps = {
  images: [],
  showButtons: false,
};

const PhotoCarousel = ({
  images,
  showButtons,
  isDesktop, 
}) => (
  <>
    <Carousel
      cellSpacing={20}
      showButtons={showButtons}
      showPaging={true}
      containerClassName='photo-carousel'
    >
      {images.map(src => (
        <Photo key={nanoid()} src={src.image} imgStyle={{
          objectFit: 'contain', objectPosition: 'top', 
        }} />
      ))}
    </Carousel>
    <style global jsx>{`
      div.slider-control-centerright.photo-carousel a,
      div.slider-control-centerleft.photo-carousel a {
        margin: 0;
        color: #e5e5e5;
      }
      div.slider-frame {
        max-height: ${isDesktop
    ? 'calc(80vh - 4.375rem) !important'
    : 'auto !important'};
      }
    `}</style>
  </>
);

PhotoCarousel.defaultProps = defaultProps;

export default PhotoCarousel;
